/* tslint:disable */
/* eslint-disable */
/**
 * gRPC for our DBaaS central service
 * notably uses gRPC-Gateway with OpenAPI
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */
export enum ClusterStatus {
    UNSPECIFIED = 'UNSPECIFIED',
    INITIALIZE = 'INITIALIZE',
    PREPARE = 'PREPARE',
    LAUNCH = 'LAUNCH',
    NORMAL = 'NORMAL',
    SCALING = 'SCALING',
    RECOVERING = 'RECOVERING',
    DELETED = 'DELETED',
    DELETECOMPLETE = 'DELETECOMPLETE',
    CLEARED = 'CLEARED'
}

/**
 * 
 * @export
 * @interface DebugPortalDashboardLink
 */
export interface DebugPortalDashboardLink {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDashboardLink
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDashboardLink
     */
    link: string;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalExchangeOAuthTokenReq
 */
export interface DebugPortalDebugPortalExchangeOAuthTokenReq {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalExchangeOAuthTokenReq
     */
    redirect_uri: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalExchangeOAuthTokenReq
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalExchangeOAuthTokenReq
     */
    state: string;
    /**
     * Whether the returned session key should be placed in the cookie.
     * @type {boolean}
     * @memberof DebugPortalDebugPortalExchangeOAuthTokenReq
     */
    session_key_as_cookie: boolean;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalExchangeOAuthTokenResp
 */
export interface DebugPortalDebugPortalExchangeOAuthTokenResp {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalExchangeOAuthTokenResp
     */
    session_key: string;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalGetBasicSessionResp
 */
export interface DebugPortalDebugPortalGetBasicSessionResp {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalGetBasicSessionResp
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalGetBasicSessionResp
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalGetBasicSessionResp
     */
    csrf_token: string;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalGetOAuthConfigResp
 */
export interface DebugPortalDebugPortalGetOAuthConfigResp {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalGetOAuthConfigResp
     */
    auth_url: string;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalSignOutReq
 */
export interface DebugPortalDebugPortalSignOutReq {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalSignOutReq
     */
    redirect_uri: string;
    /**
     * Whether the returned session key was placed in the cookie.
     * @type {boolean}
     * @memberof DebugPortalDebugPortalSignOutReq
     */
    session_key_as_cookie: boolean;
}
/**
 * 
 * @export
 * @interface DebugPortalDebugPortalSignOutResp
 */
export interface DebugPortalDebugPortalSignOutResp {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalDebugPortalSignOutResp
     */
    oauth_sign_out_uri: string;
}
/**
 * 
 * @export
 * @interface DebugPortalGetDashboardLinksResp
 */
export interface DebugPortalGetDashboardLinksResp {
    /**
     * 
     * @type {Array<DebugPortalDashboardLink>}
     * @memberof DebugPortalGetDashboardLinksResp
     */
    dashboards: Array<DebugPortalDashboardLink>;
}
/**
 * 
 * @export
 * @interface DebugPortalListTenantClustersResp
 */
export interface DebugPortalListTenantClustersResp {
    /**
     * 
     * @type {number}
     * @memberof DebugPortalListTenantClustersResp
     */
    total: number;
    /**
     * 
     * @type {Array<DebugPortalTenantCluster>}
     * @memberof DebugPortalListTenantClustersResp
     */
    items: Array<DebugPortalTenantCluster>;
}
/**
 * 
 * @export
 * @interface DebugPortalListTenantsResp
 */
export interface DebugPortalListTenantsResp {
    /**
     * 
     * @type {number}
     * @memberof DebugPortalListTenantsResp
     */
    total: number;
    /**
     * 
     * @type {Array<DebugPortalTenant>}
     * @memberof DebugPortalListTenantsResp
     */
    items: Array<DebugPortalTenant>;
}
/**
 * 
 * @export
 * @interface DebugPortalTenant
 */
export interface DebugPortalTenant {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DebugPortalTenant
     */
    timezone: number;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    plan: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    discount: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    discount_description: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    bind_credit_at: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenant
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof DebugPortalTenant
     */
    has_discount: boolean;
}
/**
 * 
 * @export
 * @interface DebugPortalTenantCluster
 */
export interface DebugPortalTenantCluster {
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    profile: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    create_time: string;
    /**
     * 
     * @type {DebugPortalTenantComponents}
     * @memberof DebugPortalTenantCluster
     */
    tenant_components: DebugPortalTenantComponents;
    /**
     * 
     * @type {ClusterStatus}
     * @memberof DebugPortalTenantCluster
     */
    status: ClusterStatus;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantCluster
     */
    cross_account_deployment_id?: string;
}
/**
 * 
 * @export
 * @interface DebugPortalTenantComponent
 */
export interface DebugPortalTenantComponent {
    /**
     * 
     * @type {number}
     * @memberof DebugPortalTenantComponent
     */
    replicas: number;
    /**
     * 
     * @type {string}
     * @memberof DebugPortalTenantComponent
     */
    machineType: string;
}
/**
 * 
 * @export
 * @interface DebugPortalTenantComponents
 */
export interface DebugPortalTenantComponents {
    /**
     * 
     * @type {DebugPortalTenantComponent}
     * @memberof DebugPortalTenantComponents
     */
    pd: DebugPortalTenantComponent;
    /**
     * 
     * @type {DebugPortalTenantComponent}
     * @memberof DebugPortalTenantComponents
     */
    tikv: DebugPortalTenantComponent;
    /**
     * 
     * @type {DebugPortalTenantComponent}
     * @memberof DebugPortalTenantComponents
     */
    tidb: DebugPortalTenantComponent;
    /**
     * 
     * @type {DebugPortalTenantComponent}
     * @memberof DebugPortalTenantComponents
     */
    tiflash: DebugPortalTenantComponent;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := ptypes.MarshalAny(foo)      ...      foo := &pb.Foo{}      if err := ptypes.UnmarshalAny(any, foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON ==== The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    type_url?: string;
    /**
     * Must be a valid serialized protocol buffer of the above specified type.
     * @type {string}
     * @memberof ProtobufAny
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface RuntimeError
 */
export interface RuntimeError {
    /**
     * 
     * @type {string}
     * @memberof RuntimeError
     */
    error?: string;
    /**
     * 
     * @type {number}
     * @memberof RuntimeError
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeError
     */
    message?: string;
    /**
     * 
     * @type {Array<ProtobufAny>}
     * @memberof RuntimeError
     */
    details?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @interface UserDebugAuthorization
 */
export interface UserDebugAuthorization {
    /**
     * 
     * @type {string}
     * @memberof UserDebugAuthorization
     */
    token?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDebugAuthorization
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface UserDebugFeatureList
 */
export interface UserDebugFeatureList {
    /**
     * 
     * @type {string}
     * @memberof UserDebugFeatureList
     */
    org_id?: string;
    /**
     * 
     * @type {Array<UserDebugFeatureListFeatures>}
     * @memberof UserDebugFeatureList
     */
    features?: Array<UserDebugFeatureListFeatures>;
}
/**
 * 
 * @export
 * @interface UserDebugFeatureListFeatures
 */
export interface UserDebugFeatureListFeatures {
    /**
     * 
     * @type {string}
     * @memberof UserDebugFeatureListFeatures
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDebugFeatureListFeatures
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface UserDebugResponseMessage
 */
export interface UserDebugResponseMessage {
    /**
     * 
     * @type {number}
     * @memberof UserDebugResponseMessage
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDebugResponseMessage
     */
    message?: string;
}

/**
 * CentralDebugPortalServiceApi - axios parameter creator
 * @export
 */
export const CentralDebugPortalServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DebugPortalDebugPortalExchangeOAuthTokenReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalExchangeOAuthToken: async (body: DebugPortalDebugPortalExchangeOAuthTokenReq, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling debugPortalExchangeOAuthToken.');
            }
            const localVarPath = `/debug-api/v1/oauth/exchange`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetBasicSession: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/debug-api/v1/me`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetDashboardLinks: async (orgId: string, clusterId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling debugPortalGetDashboardLinks.');
            }
            // verify required parameter 'clusterId' is not null or undefined
            if (clusterId === null || clusterId === undefined) {
                throw new RequiredError('clusterId','Required parameter clusterId was null or undefined when calling debugPortalGetDashboardLinks.');
            }
            const localVarPath = `/debug-api/v1/orgs/{org_id}/clusters/{cluster_id}/dashboard_links`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"cluster_id"}}`, encodeURIComponent(String(clusterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetOAuthConfig: async (redirectUri?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/debug-api/v1/oauth/config`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetTenantById: async (orgId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling debugPortalGetTenantById.');
            }
            const localVarPath = `/debug-api/v1/orgs/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalListTenantClusters: async (orgId: string, page?: number, perPage?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling debugPortalListTenantClusters.');
            }
            const localVarPath = `/debug-api/v1/orgs/{org_id}/clusters`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {string} [email] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalListTenants: async (name?: string, id?: string, page?: number, perPage?: number, email?: string, status?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/debug-api/v1/orgs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DebugPortalDebugPortalSignOutReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalSignOut: async (body: DebugPortalDebugPortalSignOutReq, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling debugPortalSignOut.');
            }
            const localVarPath = `/debug-api/v1/auth/sign_out`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organization 
         * @param {string} cluster 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebugAuthorizationStatus: async (organization: string, cluster: string, user?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organization' is not null or undefined
            if (organization === null || organization === undefined) {
                throw new RequiredError('organization','Required parameter organization was null or undefined when calling getUserDebugAuthorizationStatus.');
            }
            // verify required parameter 'cluster' is not null or undefined
            if (cluster === null || cluster === undefined) {
                throw new RequiredError('cluster','Required parameter cluster was null or undefined when calling getUserDebugAuthorizationStatus.');
            }
            const localVarPath = `/api/userdebug/v1/{organization}/{cluster}/authorization`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)))
                .replace(`{${"cluster"}}`, encodeURIComponent(String(cluster)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebugFeatureList: async (organization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organization' is not null or undefined
            if (organization === null || organization === undefined) {
                throw new RequiredError('organization','Required parameter organization was null or undefined when calling getUserDebugFeatureList.');
            }
            const localVarPath = `/api/userdebug/v1/{organization}/features`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CentralDebugPortalServiceApi - functional programming interface
 * @export
 */
export const CentralDebugPortalServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DebugPortalDebugPortalExchangeOAuthTokenReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalExchangeOAuthToken(body: DebugPortalDebugPortalExchangeOAuthTokenReq, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalDebugPortalExchangeOAuthTokenResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalExchangeOAuthToken(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalGetBasicSession(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalDebugPortalGetBasicSessionResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalGetBasicSession(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalGetDashboardLinks(orgId: string, clusterId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalGetDashboardLinksResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalGetDashboardLinks(orgId, clusterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalGetOAuthConfig(redirectUri?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalDebugPortalGetOAuthConfigResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalGetOAuthConfig(redirectUri, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalGetTenantById(orgId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalTenant>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalGetTenantById(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalListTenantClusters(orgId: string, page?: number, perPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalListTenantClustersResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalListTenantClusters(orgId, page, perPage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {string} [email] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalListTenants(name?: string, id?: string, page?: number, perPage?: number, email?: string, status?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalListTenantsResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalListTenants(name, id, page, perPage, email, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {DebugPortalDebugPortalSignOutReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugPortalSignOut(body: DebugPortalDebugPortalSignOutReq, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DebugPortalDebugPortalSignOutResp>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).debugPortalSignOut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} organization 
         * @param {string} cluster 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDebugAuthorizationStatus(organization: string, cluster: string, user?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDebugAuthorization>>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).getUserDebugAuthorizationStatus(organization, cluster, user, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} organization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDebugFeatureList(organization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDebugFeatureList>> {
            const localVarAxiosArgs = await CentralDebugPortalServiceApiAxiosParamCreator(configuration).getUserDebugFeatureList(organization, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CentralDebugPortalServiceApi - factory interface
 * @export
 */
export const CentralDebugPortalServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {DebugPortalDebugPortalExchangeOAuthTokenReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalExchangeOAuthToken(body: DebugPortalDebugPortalExchangeOAuthTokenReq, options?: any): AxiosPromise<DebugPortalDebugPortalExchangeOAuthTokenResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalExchangeOAuthToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetBasicSession(options?: any): AxiosPromise<DebugPortalDebugPortalGetBasicSessionResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalGetBasicSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} clusterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetDashboardLinks(orgId: string, clusterId: string, options?: any): AxiosPromise<DebugPortalGetDashboardLinksResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalGetDashboardLinks(orgId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetOAuthConfig(redirectUri?: string, options?: any): AxiosPromise<DebugPortalDebugPortalGetOAuthConfigResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalGetOAuthConfig(redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalGetTenantById(orgId: string, options?: any): AxiosPromise<DebugPortalTenant> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalGetTenantById(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalListTenantClusters(orgId: string, page?: number, perPage?: number, options?: any): AxiosPromise<DebugPortalListTenantClustersResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalListTenantClusters(orgId, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {string} [email] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalListTenants(name?: string, id?: string, page?: number, perPage?: number, email?: string, status?: Array<string>, options?: any): AxiosPromise<DebugPortalListTenantsResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalListTenants(name, id, page, perPage, email, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DebugPortalDebugPortalSignOutReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugPortalSignOut(body: DebugPortalDebugPortalSignOutReq, options?: any): AxiosPromise<DebugPortalDebugPortalSignOutResp> {
            return CentralDebugPortalServiceApiFp(configuration).debugPortalSignOut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organization 
         * @param {string} cluster 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebugAuthorizationStatus(organization: string, cluster: string, user?: string, options?: any): AxiosPromise<Array<UserDebugAuthorization>> {
            return CentralDebugPortalServiceApiFp(configuration).getUserDebugAuthorizationStatus(organization, cluster, user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebugFeatureList(organization: string, options?: any): AxiosPromise<UserDebugFeatureList> {
            return CentralDebugPortalServiceApiFp(configuration).getUserDebugFeatureList(organization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CentralDebugPortalServiceApi - object-oriented interface
 * @export
 * @class CentralDebugPortalServiceApi
 * @extends {BaseAPI}
 */
export class CentralDebugPortalServiceApi extends BaseAPI {
    /**
     * 
     * @param {DebugPortalDebugPortalExchangeOAuthTokenReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalExchangeOAuthToken(body: DebugPortalDebugPortalExchangeOAuthTokenReq, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalExchangeOAuthToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalGetBasicSession(options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalGetBasicSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} clusterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalGetDashboardLinks(orgId: string, clusterId: string, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalGetDashboardLinks(orgId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [redirectUri] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalGetOAuthConfig(redirectUri?: string, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalGetOAuthConfig(redirectUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalGetTenantById(orgId: string, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalGetTenantById(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalListTenantClusters(orgId: string, page?: number, perPage?: number, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalListTenantClusters(orgId, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [id] 
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {string} [email] 
     * @param {Array<string>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalListTenants(name?: string, id?: string, page?: number, perPage?: number, email?: string, status?: Array<string>, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalListTenants(name, id, page, perPage, email, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DebugPortalDebugPortalSignOutReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public debugPortalSignOut(body: DebugPortalDebugPortalSignOutReq, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).debugPortalSignOut(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organization 
     * @param {string} cluster 
     * @param {string} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public getUserDebugAuthorizationStatus(organization: string, cluster: string, user?: string, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).getUserDebugAuthorizationStatus(organization, cluster, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CentralDebugPortalServiceApi
     */
    public getUserDebugFeatureList(organization: string, options?: any) {
        return CentralDebugPortalServiceApiFp(this.configuration).getUserDebugFeatureList(organization, options).then((request) => request(this.axios, this.basePath));
    }
}


